<template>
            <div class="network-detail" >
              <template v-if="data.SystemUpgrading" >
                <SystemUpdating/>
              </template>
              <template>
                <template v-if="showNetWorkInfo">
                  <div class="details-center">
                    <div class="name">
                      <p class="title">当前套餐：</p>
                      <p class="content">{{data.packageName || '-'}}</p>
                    </div>
                    <div class="list">
                      <div class="left">
                        <p class="title">使用流量：</p>
                        <p class="content">{{data.packageFlow  || '-'}}G/{{data.flowSum  || '-'}}G</p>
                      </div>
                      <div class="right">
                        <p class="title">剩余流量：</p>
                        <p class="content">{{data.residueFlow  || '-'}}G</p>
                      </div>
                    </div>
                    <div class="list">
                      <div class="left">
                        <p class="title">账户金额：</p>
                        <p class="content">{{data.accountBalance  || '-'}}元</p>
                      </div>
                      <div class="right">
                        <p class="title">结算金额：</p>
                        <p class="content">{{data.residueBalance || '-'}}元</p>
                      </div>
                    </div>

                    <div class="process-wrap">
                      <div class="process-item" v-for="(item,index) in data.flowList" :key="index">
                        <div class="title">
                          <p class="mounth">{{item.flowMonth}}月流量使用情况</p>
                          <p class="number">{{item.flowUsedBytes}}G/{{item.flowSumBytes}}G</p>
                        </div>

                        <el-progress  :percentage=" ((parseFloat(item.flowUsedBytes))/parseFloat(item.flowSumBytes))*100" :show-text="false"></el-progress>

                      </div>
                    </div>
                  </div>
                  <GoMore text="套餐变更以及更详细信息&gt;&gt;" :jumpUrl="data.pcUrl"/>
                </template>
                <template v-else>
                  <div class="network-detail-noRegistered">
                    <img :src="require('@/assets/Home/Index/nodata-new.png')"/>
                    <span>您还未开通网络</span>
                    <el-button round type="primary" @click="addNetWorkAccount">去开通</el-button>


                  </div>

                </template>

              </template>


            </div>
    
</template>

<script>
    import GoMore from "./GoMore"
    import SystemUpdating from "./SystemUpdating"
    export default {
        name: "Books",
        components: {
            GoMore,
          SystemUpdating
        },
        props: {
            data:  { type: Object, default:()=>{}},
          showNetWorkInfo: { type: Boolean, default:true},
        },
      methods:{
        addNetWorkAccount(){
          this.$router.push({name:'AddNetworkAccount'});
        }
      }
    }
</script>

<style scoped lang="scss">
    .network-detail {
        height: 253px;
        background: #e8eaf3;
        .details-center {
            display: flex;
            flex-wrap: wrap;
          padding: 32px 25px 21px 22px;
            .name {
                width: 100%;
                display: flex;
            }
            .list {
                display: flex;
                justify-content: space-between;
                p {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    min-width: 70px;
                    font-size: 12px;
                }
                .left {
                   width: 55%;
                    display: flex;

                }
                .right {
                   width: 45%;
                    display: flex;

                }

            }
            .process-wrap {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                margin-top: 10px;
                z-index:0;
                .process-item {
                    width: 100%;
                    .title {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 6px;
                    }
                    .process {
                        width: 100%;
                        height: 10px;
                        background-color: #DDD;
                        position: relative;
                        .content {
                            width: 0%;
                            height: 10px;
                            position: absolute;
                            top: 0;
                            left: 0;
                            background-image: linear-gradient(to right,green,orange);
                        }
                    }
                }
            }
        }
        .more-recode {
            margin-top: 15px;
            padding-right: 31px;
            text-align: right;
            font-size: 12px;
            color: #3a3550;
        }
      &-noRegistered {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 128px;
          display: inline-block;
          margin-top: 30px;
        }
        span {
          margin-top: 15px;
          margin-bottom: 10px;
        }
      }


    }

</style>